import React, { Component } from "react";
import PayrollPayment from "../../../components/PayrollPayment/PayrollPayment";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PayrollForm
Description : Componente que invoca al componente Payroll, para la configuración de la nómina.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Payroll
================================================================================ */
class PayrollPaymentForm extends Component{
    render(){
        return(
            <PayrollPayment/>  
        )   
    }
}

export default PayrollPaymentForm;